import React, { useEffect, useState } from "react"
import { notify } from "../utilComponents/Notification";
import { fetchChargesData, fetchSubscriptionData } from "../apis/billingCardApi";

const BillingCard = ({ locationId }) => {

    const [charges, setCharges] = useState([
        {
            "id": "n/a",
            "date": "n/a",
            "amount": "n/a",
            "status": "n/a",
            "description": "n/a"
        }
    ]);

    const [subscriptions, setSubscriptions] = useState([
        {
            "id": "n/a",
            "subscriptionStartDate": "n/a",
            "subscriptionEndDate": "n/a",
            "subscriptionCreatedDate": "n/a",
            "customer": "n/a",
            "status": "n/a",
            "description": "n/a"
        }
    ]);

    useEffect(() => {
        const getChargesData = async () => {
            try{
                const chargesData = await fetchChargesData(locationId);
                setCharges(chargesData.charges);
            } catch(error){
                notify('error', 'Charges Data', error.message);
            }
        }

        const getSubscriptionData = async () => {
            try{
                const subscriptionData = await fetchSubscriptionData(locationId);
                setSubscriptions(subscriptionData.subscriptions);
            } catch(error){
                notify('error', 'Subscription Data', error.message);
            }
        }
        getChargesData();
        getSubscriptionData();
    }, []);

    const [activeView, setActiveView] = useState("charges");
    const [filterOption, setFilterOption] = useState("");

    const handleViewChange = (view) => {
        setActiveView(view);
        setFilterOption("");
    };

    const handleDropdownChange = (e) => {
        setFilterOption(e.target.value);
    };

    const dropdownOptions =
        activeView === "charges"
            ? ["succeeded", "failed", "pending"]
            : ["active", "canceled", "paused", "unpaid", "past_due"];

    return (
        <div className="billing-card-content">

            <div className="billing-card-tabs">
                <button
                    className={`billing-tab ${activeView === "charges" ? "active" : ""}`}
                    onClick={() => handleViewChange("charges")}
                >
                    Charges
                </button>
                <button
                    className={`billing-tab ${activeView === "subscriptions" ? "active" : ""}`}
                    onClick={() => handleViewChange("subscriptions")}
                >
                    Subscriptions
                </button>

                {/* dropdown */}
                <div className="dropdown-container">
                    <select
                        value={filterOption}
                        onChange={handleDropdownChange}
                        className="filter-dropdown"
                    >
                        <option value="" disabled>
                            Filter by Status
                        </option>
                        {dropdownOptions.map((option, index) => (
                            <option key={index} value={option}>
                                {option}
                            </option>
                        ))}
                    </select>
                </div>
            </div>

            {/* charges table */}
            {activeView === "charges" &&
                <div className='billing-table'>
                    <table>
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Amount</th>
                                <th>Status</th>
                                <th>Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            {charges
                                .filter((charge) =>
                                    filterOption ? charge.status === filterOption : true
                                )
                                .map((charge) => (
                                    <tr key={charge.id}>
                                        <td>{charge.date}</td>
                                        <td>{charge.amount}</td>
                                        <td>{charge.status}</td>
                                        <td>{charge.description.length < 25 ? charge.description : charge.description.slice(0, 18)}</td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </div>
            }

            {/* subscription table */}
            {activeView === "subscriptions" &&
                <div className='billing-table'>
                    <table>
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Amount</th>
                                <th>Status</th>
                                <th>Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            {subscriptions
                                .filter((subscription) =>
                                    filterOption ? subscription.status === filterOption : true
                                )
                                .map((subscription) => (
                                    <tr key={subscription.id}>
                                        <td>{subscription.subscriptionStartDate}</td>
                                        <td>{subscription.subscriptionEndDate}</td>
                                        <td>{subscription.status}</td>
                                        <td>{subscription.description}</td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </div>
            }
        </div>
    )
}

export default BillingCard;